import React, { Component } from "react";
import AudioWorkHeaderRender from "./children/AudioWorkHeaderRender";
import "@/assets/audioCutSpeedVolume.less";

class AudioWorkHeaderFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <AudioWorkHeaderRender pageWork={this.props.pageWork} handelPageWorkChange={this.props.handelPageWorkChange} />
    );
  }
}

export default AudioWorkHeaderFunction;
